// extracted by mini-css-extract-plugin
module.exports = {"checkbox-container":"Checkbox_checkbox-container__zXmRf","secondary":"Checkbox_secondary__rtQPE","survey":"Checkbox_survey__WbwaC"};